import { useCustomMutation } from "@refinedev/core";
import { notification } from "antd";
import { SUBMIT_RECEIVING_MUTATION } from "../queries";

interface SubmitReceivingResponse {
  id: string;
  receivingNo: string;
  status: string;
  approvalType?: string;
  steps?: Array<{
    order: number;
    roleSlug: string;
    stepName?: string;
  }>;
  externalWorkflow?: Record<string, any>;
  approvalData?: any;
  flowCaseId?: string;
  flowCaseNumber?: string;
  submittedBy?: string;
}

interface UseSubmitReceivingProps {
  onSuccess?: (data: SubmitReceivingResponse) => void;
  onError?: (error: any) => void;
}

export const useSubmitReceiving = ({
  onSuccess,
  onError
}: UseSubmitReceivingProps = {}) => {
  const { mutate: submitReceiving, isLoading } = useCustomMutation<SubmitReceivingResponse>();

  const submit = async (input: { receivingId?: string; receivingData?: any; fiscalYear?: number }) => {
    try {
      const values = {
        input: {
          receivingId: input.receivingId,
          receivingData: input.receivingData,
          fiscalYear: input.fiscalYear
        }
      };

      submitReceiving({
        meta: {
          gqlMutation: SUBMIT_RECEIVING_MUTATION,
        },
        values: values,
        url: "",
        method: "post"
      }, {
        onSuccess: (data) => {
          const response = (data as any)?.data?.submitReceiving || data;

          notification.success({
            message: 'Receiving Submitted Successfully',
            description: 'The receiving has been submitted for approval.',
          });
          onSuccess?.(response);
        },
        onError: (error) => {
          notification.error({
            message: 'Submission Failed',
            description: error.message || 'Failed to submit the receiving.',
          });
          onError?.(error);
        }
      });
    } catch (error) {
      console.error('Error submitting receiving:', error);
      onError?.(error);
    }
  };

  return {
    submit,
    isLoading
  };
};